module.exports = __webpack_public_path__ + "fonts/Zen_Maru_Gothic-500-[33]276.0e0cf05.woff2";